import { engineComponent, NumberUtils } from "neo-common";
import { Communication } from "neo-games";
import { ComponentTypes } from "../Components/ComponentTypes";
import { Settings } from "./Settings";
import { WinAnimatorExtended } from "./WinAnimatorExtended";
import { Symbols } from "../GameComponents/Symbols";
import { PaylinesExtended } from "./PaylinesExtended";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { BaseView } from "../GameComponents/Base/BaseView";
import { FreespinsView } from "../GameComponents/Freespins/FreespinsView";
import { Symbol } from "../GameComponents/Symbol";
import { PaylinesDefinitions } from "../GameComponents/PaylinesDefinitions";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { PlayList } from "../Components/Sounds/PlayList";

@engineComponent(ComponentTypes.DisplayObject)
export class WinAnimatorExtendedFS extends WinAnimatorExtended {
    private _bgParticles: SwitchElement;
    public overlaySymbols: Array<Array<Symbol>>;

    public isWild: boolean = false;

    initialize(
        symbols: Symbols,
        paylines?: PaylinesExtended,
        noWinSymbolsContainer?: ContainerElement,
        symbolsContainer?: ContainerElement,
        parent?: BaseView | FreespinsView,
    ): void {
        super.initialize(symbols, paylines, noWinSymbolsContainer, symbolsContainer, parent);
    }

    public onReelStopped(reelsData: Array<Communication.Game.IReel>, reelIndex: number): void {
        this.currentReels = reelsData;

        for (let i = 0; i < reelsData[reelIndex].symbols.length; i++) {
            this.removeCurrentSymbol(reelIndex, i);
        }

        for (let i = reelsData[reelIndex].symbols.length - 1; i >= 0; i--) {
            this.addCurrentSymbol(reelIndex, i);
        }
    }

    public resetOverlay(): void {
        if (this.overlaySymbols == null) {
            return;
        }

        for (let i = 0; i < this.reelCount; i++) {
            for (let j = 0; j < this.symbolCount; j++) {
                if (this.overlaySymbols[i][j] != null) {
                    if (this.symbols != null) {
                        this.symbols.returnSymbol(this.overlaySymbols[i][j]);
                        this.overlaySymbols[i][j] = null;
                    }
                }
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/CustomComponents/WinAnimatorExtendedFS.ts
 **/